var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIconMist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.11113 7.65C8.562 7.65 8.9944 7.47089 9.31321 7.15208C9.63203 6.83327 9.81113 6.40087 9.81113 5.95C9.81113 5.49913 9.63203 5.06673 9.31321 4.74792C8.9944 4.42911 8.562 4.25 8.11113 4.25C7.66026 4.25 7.22786 4.42911 6.90905 4.74792C6.59024 5.06673 6.41113 5.49913 6.41113 5.95C6.41113 6.40087 6.59024 6.83327 6.90905 7.15208C7.22786 7.47089 7.66026 7.65 8.11113 7.65Z",
    fill: "#B2A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.95C1.0829 2.50155 4.3044 0 8.1107 0C11.917 0 15.1385 2.50155 16.2214 5.95C15.1385 9.39845 11.917 11.9 8.1107 11.9C4.3044 11.9 1.0829 9.39845 0 5.95ZM11.5107 5.95C11.5107 6.85174 11.1525 7.71654 10.5149 8.35416C9.87724 8.99179 9.01244 9.35 8.1107 9.35C7.20896 9.35 6.34416 8.99179 5.70654 8.35416C5.06891 7.71654 4.7107 6.85174 4.7107 5.95C4.7107 5.04826 5.06891 4.18346 5.70654 3.54584C6.34416 2.90821 7.20896 2.55 8.1107 2.55C9.01244 2.55 9.87724 2.90821 10.5149 3.54584C11.1525 4.18346 11.5107 5.04826 11.5107 5.95Z",
    fill: "#B2A5A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconMist);
export default __webpack_public_path__ + "static/media/eyeIconMist.6bb9aaf29f688027daacca450c894285.svg";
export { ForwardRef as ReactComponent };